import { memo } from "react"
import styled from "styled-components"

const ControlSafe = styled.div`
  display: flex;
  padding: 6px;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
`

const IconMenu = () => {
  return (
    <ControlSafe>
      <svg width="10" height="24" viewBox="0 0 10 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="5" cy="4" r="3" fill="#646464" />
        <circle cx="5" cy="12" r="3" fill="#646464" />
        <circle cx="5" cy="20" r="3" fill="#646464" />
      </svg>
    </ControlSafe>
  )
}

export default memo(IconMenu)
